<template>
  <a class="yadlink" href="https://t.me/rus_scheme/32" target="_blank">Группа Россхемы <font-awesome-icon :icon="['fab', 'telegram']"/></a>
  <a class="howsearch"  style="color:#7BA7AB;"  @click="openHowTo" >Как искать?</a>
  <br>
    <div class="schemes">
    <h2><a v-bind:href="yadHome">Поиск РОССХЕМА</a></h2>
    <section>
      <form @submit.prevent="submitted">
        <input v-model="val" type="text" />
        <button class="search"><font-awesome-icon icon="magnifying-glass" style="font-size: 16px;color: #F9F0DA;"/></button>
      </form>
    </section>
    <h4 v-if="schemes.length>0 && schemes.length<1000 "> Найдено: {{ schemes.length }} файлов</h4>
    <h4 v-if="schemes.length>1000"> Найдено больше 1000 файлов, уточните поисковый запрос</h4>
    <h4 v-if="!firstload && schemes.length == 0"> По запросу "{{ query }}" ничего не найдено. Найдете в другом не месте, не забудьте поделится с нами.</h4>
    <div v-if="error">
      <h2>erorr!! {{ error }}</h2>
    </div>
    <br>
    <table v-if="schemes.length>0" id="table">
      <tbody>
            <tr v-for="(scheme, index ) in schemes" :key="scheme.id">
              <td class="count">
                {{index +1 }}
              </td>
              <td>
                <div>
                  <div>
                      <a v-bind:href="scheme.fullpath" target="_blank"><font-awesome-icon icon="file" style="color:#7BA7AB; padding: 5px 15px 5px 5px;"  /><span class="scheme">{{ scheme.file }}</span></a>
                      <br>
                  </div>
<!--                  <div v-if="schemes[index + 1 ] && schemes[index + 1].dir == scheme.dir">
                      <a v-bind:href="schemes[index + 1 ].fullpath" target="_blank"><font-awesome-icon icon="file" style="color:#7BA7AB; padding: 5px 15px 5px 5px;"  /><span class="scheme">{{ schemes[ index + 1].file }}</span></a>
                      <br>
                      {{ index = index+2}}
                  </div> -->
                  <div>
                      <a v-bind:href="yadHome+scheme.dir" target="_blank"><font-awesome-icon icon="folder-open" style="color:#7BA7AB;padding: 5px 10px 5px 5px;" /><span>/{{scheme.dir}}</span></a>
                  </div>   
                </div>
              </td>
            </tr>
        </tbody>
      </table>    
  </div>
</template>

<script>
import { ref } from 'vue';
import {openModal} from "jenesius-vue-modal";
import ModalHowTo from "./ModalHowTo.vue";
export default {
  setup(){
      const val = ref("");
      const schemes = ref([]);
      const error = ref("");
      const yadHome = ref(process.env.VUE_APP_YANDEX_DISK_HOME);
      const firstload = ref(true);
      const query = ref("");
      const submitted = async()=>{
        var url = process.env.VUE_APP_API_URL || 'http://localhost:5000/api/search?text=';
        const response = await fetch(url+val.value);
        const json = await response.json();
        json.forEach( element => {
          element.dirlink = yadHome.value+element.dir;
        });
        schemes.value = json;
        firstload.value = false;
        query.value = val.value;
      }
      
      return {val , schemes, error, submitted , yadHome, firstload, query };
  },
  methods: {
        openHowTo() {
            openModal(ModalHowTo);
      },
      
    },


}
</script>

<style>
* {box-sizing: border-box;}
h2,h4 {
  text-align: center;
  padding-top: 20px;
}
h6{
  align-content: center;
}
form {
  position: relative;
  width: 50%;
  margin: 0 auto;
}
input {
  width: 100%;
  height: 42px;
  padding-left: 10px;
  border: 2px solid #7BA7AB;
  border-radius: 5px;
  outline: none;
  background: white;
  color: #9E9C9C;
}
.search {
  position: absolute; 
  top: 0;
  right: 0px;
  width: 42px;
  height: 42px;
  border: none;
  background: #7BA7AB;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
}
ul {
  width: 100%;
  padding-left: 10px;
  border: 2px solid #7BA7AB;
  border-radius: 5px;
  outline: none;
  background: white;
  color: #9E9C9C; 
}
li {
    list-style-type: none;
}
table {
    width: 80%;
    border: 1px solid #7BA7AB;
    margin: auto;
   }
.count{
    vertical-align: center;
    text-align: center;
}
td, th {
    border-bottom: 1px solid #7BA7AB;
}
#table tbody tr:nth-child(odd){
	background: #fff;
}
#table tbody tr:nth-child(even){
	background: #e4e4e4;
}
a { 
    text-decoration: none;
    color: black;
} 
.yadlink {
  position: absolute;
  top: 15px; 
  right: 15px;
  text-decoration: underline;
  color:#7BA7AB;
}
.howsearch {
  position: absolute;
  
  top: 15px; 
  left: 15px;
  text-decoration: underline;
  color:#7BA7AB;
}



</style>
